/**
 * Winner's Circle list: newest race date first, optional homepage cap.
 * Works in the browser and in Node tests (module.exports).
 */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (typeof root !== 'undefined') {
    root.MEngWinnersCircle = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  function compareEventDates(da, db) {
    da = da || '';
    db = db || '';
    if (da === db) return 0;
    if (!da) return 1;
    if (!db) return -1;
    return db < da ? -1 : 1;
  }

  function sortEntriesByEventDate(entries) {
    return entries.slice().sort(function (a, b) {
      return compareEventDates(a.eventDate, b.eventDate);
    });
  }

  function homepageWins(entries, mode, limit) {
    var sorted = sortEntriesByEventDate(entries);
    if (mode === 'picked') {
      return sorted.filter(function (entry) {
        return entry.showOnHomepage;
      });
    }
    if (mode === 'last_three') {
      return sorted.slice(0, limit || 3);
    }
    return sorted;
  }

  function winnerItems(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.winner'));
  }

  function sortWinnersList(root) {
    var items = winnerItems(root);
    if (items.length < 2) return items;
    items.sort(function (a, b) {
      return compareEventDates(
        a.getAttribute('data-event-date'),
        b.getAttribute('data-event-date')
      );
    });
    items.forEach(function (el) {
      root.appendChild(el);
    });
    return items;
  }

  function limitWinnersList(root) {
    var raw = root.getAttribute('data-limit');
    if (!raw) return;
    var limit = parseInt(raw, 10);
    if (!(limit > 0)) return;
    var extras = winnerItems(root).slice(limit);
    extras.forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  function enhanceWinnersList(root) {
    if (!root) return;
    sortWinnersList(root);
    limitWinnersList(root);
    root.classList.add('is-ready');
  }

  function enhanceAllWinnersLists(doc) {
    var lists = (doc || document).querySelectorAll('.winners-list');
    Array.prototype.forEach.call(lists, enhanceWinnersList);
  }

  return {
    compareEventDates: compareEventDates,
    sortEntriesByEventDate: sortEntriesByEventDate,
    homepageWins: homepageWins,
    sortWinnersList: sortWinnersList,
    limitWinnersList: limitWinnersList,
    enhanceWinnersList: enhanceWinnersList,
    enhanceAllWinnersLists: enhanceAllWinnersLists
  };
});
